<template>
  <section class="quote">
    <div class="wrapper">
      <p>&ldquo;I am always open and eager to learn new things, which I believe is vital given the ever-changing nature of the technology industry.&rdquo;</p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'QuoteSection',
};
</script>
